var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"withdrawal-list-wrap"},[_c('BasiceLayout',{staticClass:"withdrawal-layout",attrs:{"title":_vm.$t('buyBackTitle'),"empty-text":"loading"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }